import React from "react";
import { Navigate } from "react-router-dom";

export const isAuthenticated = () => sessionStorage.getItem("token") !== null;


const WithAuth = (Component) => {

    const AuthRoute = () => {
    const isAuth = !!sessionStorage.getItem("token");
    if (isAuth) {
        return <Navigate to="/" />;
    } else {
        return <Component />;
    }
  };

  return AuthRoute;
};

export default WithAuth;